import React, { useEffect } from 'react';
import { AppView } from 'design-system';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { showUnavailableOnWeb } from 'utils/webGate';
/**
 * Creates a web route for a screen that can't run in the browser. Opening it
 * shows the QR code modal for `appLink` and goes back, so a flow that reaches
 * it explains why it stops rather than leaving nothing on screen.
 */
export const createUnavailableOnWebScreen = (appLink, title) => {
    const UnavailableOnWebScreen = () => {
        const navigation = useMainStackNavigation();
        useEffect(() => {
            showUnavailableOnWeb(appLink, title);
            if (navigation.canGoBack()) {
                navigation.goBack();
            }
            else {
                navigation.replace('Feed');
            }
        }, [navigation]);
        return <AppView withFrame={false}/>;
    };
    return UnavailableOnWebScreen;
};
